import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../reportingHelpers";

const cellStyle = {
  border: borderStyleGray,
  borderLeft: "unset",
  alignItems: "center",
};

const headerStyle = {
  borderBottom: borderStyleGray,
  width: "100%",
  textAlign: "center",
};

const InfoCell = ({ flexBasis, label, value }) => (
  <View style={{ ...cellStyle, flexBasis }}>
    <Text style={headerStyle}>{label}</Text>
    <Text style={{ fontWeight: "bold" }}>{value}</Text>
  </View>
);

const MatchInfo = ({ fixture, intl, matchLabel }) => {
  const fixtureDate = Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(fixture.startTimeLocal));
  const fixtureStartTime = Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "numeric",
  }).format(new Date(fixture.startTimeLocal));
  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "center",
        marginTop: 6,
        marginBottom: 6,
      }}
    >
      <Text style={{ fontSize: "12", fontWeight: "bold" }}>
        {intl.formatMessage({
          id: matchLabel,
          defaultMessage: "Report",
        })}
      </Text>
      <View
        style={{
          fontSize: "10",
          flexDirection: "row",
          width: "100%",
          borderLeft: borderStyleGray,
          marginTop: 6,
        }}
      >
        <InfoCell
          label={intl.formatMessage({
            id: "reports.matchReport.matchNumber",
            defaultMessage: "Match #",
          })}
          value={fixture.fixtureNumber ?? "-"}
          flexBasis="15%"
        />
        <InfoCell
          label={intl.formatMessage({ id: "date", defaultMessage: "Date" })}
          value={fixtureDate}
          flexBasis="20%"
        />
        <InfoCell
          label={intl.formatMessage({ id: "time", defaultMessage: "Time" })}
          value={fixtureStartTime}
          flexBasis="15%"
        />
        <InfoCell
          label={intl.formatMessage({
            id: "reports.matchReport.poolName",
            defaultMessage: "Pool / Class",
          })}
          value={fixture.poolName ?? "-"}
          flexBasis="20%"
        />
        <InfoCell
          label={intl.formatMessage({
            id: "reports.matchReport.venueName",
            defaultMessage: "Pitch",
          })}
          value={fixture.venueName}
          flexBasis="30%"
        />
      </View>
    </View>
  );
};

export default MatchInfo;
